import { AdCreativeFormat, AdSystem } from "services/api-service/types"

type AdSystemPresentation = {
  label: string
  icon: string
  creativeNote: string | null
  formatHints: Partial<Record<AdCreativeFormat, string>>
}

export const AD_SYSTEMS: Record<AdSystem, AdSystemPresentation> = {
  meta_ads: {
    label: "Meta Ads",
    icon: "icon-facebook",
    creativeNote:
      "Meta nie pozwala łączyć zdjęć i wideo w jednej reklamie. Każda kreacja to osobna reklama z tym samym tekstem — dodaj drugą, jeśli chcesz puścić zdjęcia i film naraz.",
    formatHints: { square: "domyślna", vertical: "feed", story: "stories i reels" },
  },
}

const FORMAT_RATIOS: Record<AdCreativeFormat, string> = {
  square: "1:1",
  vertical: "4:5",
  story: "9:16",
}

const CALL_TO_ACTION_LABELS: Record<string, string> = {
  LEARN_MORE: "Dowiedz się więcej",
  SIGN_UP: "Zarejestruj się",
  CONTACT_US: "Skontaktuj się",
}

export const adSystemLabel = (system: AdSystem) => AD_SYSTEMS[system]?.label ?? system

export const adSystemIcon = (system: AdSystem) => AD_SYSTEMS[system]?.icon

export const callToActionLabel = (value: string) => CALL_TO_ACTION_LABELS[value] ?? value

export const formatLabel = (system: AdSystem, format: AdCreativeFormat, required: boolean) => {
  const hint = AD_SYSTEMS[system]?.formatHints[format]
  return `Cloudinary ${FORMAT_RATIOS[format]}${hint ? ` — ${hint}` : ""} (${required ? "wymagane" : "opcjonalne"})`
}
